import styled, { css, DefaultTheme } from 'styled-components';

import { SectionBannerAppProps } from './types';

const modifier = {
	marginBottom: (theme: DefaultTheme) => css`
		margin-bottom: 6.4rem;

		@media (min-width: ${theme.breakpoints.desktop}) {
			margin-bottom: 9.6rem;
		}
	`,
};

export const SectionWrapper = styled.section<
	Pick<SectionBannerAppProps, 'marginBottom'>
>`
	${({ theme, marginBottom }) => css`
		margin-bottom: 0;
		${marginBottom === 'default' && modifier.marginBottom(theme)}
	`}
`;
